// Shared labels / formatters of the fleet pages.

export const ENGINE_KEYS = ['CLIMAX', 'MOM', 'I5', 'J1', 'MB2', 'TS']

export const ENGINE_INFO = {
  CLIMAX: { label: 'Climax', desc: 'Kapitülasyon dibini alır (1s, long)' },
  MOM: { label: 'mom-F', desc: 'İvmelenen momentum (6s, long)' },
  I5: { label: 'I5', desc: 'Sıkışma kırılımı (4s, iki yönlü)' },
  J1: { label: 'J1', desc: 'Yeni listeleme short (yarım boy)' },
  MB2: { label: 'MB-v2', desc: '4s trend devamı (long)' },
  TS: { label: 'TMA-short', desc: '4s trend short' },
}

export const STATUS_INFO = {
  DRAFT: { label: 'Taslak', variant: 'light-secondary' },
  RUNNING: { label: 'Çalışıyor', variant: 'light-success' },
  PAUSED: { label: 'Duraklatıldı', variant: 'light-warning' },
  STOPPED: { label: 'Durduruldu', variant: 'light-dark' },
  KILLED: { label: 'Acil kapatılıyor', variant: 'light-danger' },
}

export const SIZING_INFO = {
  FIXED: { label: 'Sabit', desc: 'Sermaye sabit kalır, kâr birikir. Test edilen ana mod.', badge: 'önerilen', variant: 'success' },
  HALF: { label: 'Yarı artan', desc: 'Kârın yarısı çeyrek başlarında sermayeye eklenir.', badge: 'orta risk', variant: 'warning' },
  FULL: { label: 'Tam artan', desc: 'Kâr ve zarar çeyrek başlarında tamamen sermayeye eklenir.', badge: 'en yüksek risk', variant: 'danger' },
}

export const POOL_INFO = {
  FREE: { label: 'Serbest', variant: 'light-success', desc: 'Ayrılmış slot yok; motorlar yalnız üst sınırlarıyla paylaşır (test edilen).' },
  LOCKED: { label: 'Kilitli', variant: 'light-warning', desc: 'Her motorun slotu sabit (min = max), toplam slotu dolduruyor.' },
  MIXED: { label: 'Karma', variant: 'light-info', desc: 'Bazı motorlara ayrılmış slot var, kalan slotlar serbest.' },
}

export const REASON_INFO = {
  disabled: 'Motor kapalı',
  coinBusy: 'Coin bu filoda açık',
  coinBusyAccount: 'Coin hesapta başka yerde açık',
  slotsFull: 'Slotlar dolu',
  engineMax: 'Motor üst sınırında',
  reserved: 'Kalan slotlar başka motorlara ayrılmış',
  margin: 'Marj yetersiz',
  f1: 'J1 filtresi (F1) geçmedi',
  noBot: 'Boş slot botu yok',
  belowMinQty: 'Borsa minimum miktarının altında',
  belowMinNotional: 'Borsa minimum tutarının altında',
  noRules: 'Borsa kuralları alınamadı',
  protectiveFailed: 'Koruyucu stop konamadı, poz kapatıldı',
  dead: 'Cüzdan tükendi',
}

export const CLOSE_REASON_INFO = {
  fleet_stop: 'Stop', fleet_tp: 'Kâr al', fleet_trail: 'İz süren stop', fleet_time: 'Süre doldu', fleet_kill: 'Acil kapatma', fleet_liquidation: 'Likidasyon', fleet_external: 'Borsada kapandı',
}

export function formatUsd(v, sign = false) {
  const n = Number(v)
  if (v == null || !Number.isFinite(n)) return '—'
  const s = n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  return `${sign && n > 0 ? '+' : ''}${s} $`
}

export function formatPct(v, sign = true) {
  const n = Number(v)
  if (v == null || !Number.isFinite(n)) return '—'
  return `${sign && n > 0 ? '+' : ''}${n.toFixed(2)}%`
}

export function formatNum(v, d = 4) {
  const n = Number(v)
  if (v == null || !Number.isFinite(n)) return '—'
  return n.toLocaleString('tr-TR', { maximumFractionDigits: d })
}

export function formatTime(v) {
  if (v == null) return '—'
  const d = new Date(typeof v === 'string' && /^\d+$/.test(v) ? Number(v) : v)
  return Number.isNaN(d.getTime()) ? String(v) : d.toLocaleString('tr-TR')
}

export function formatDuration(ms) {
  if (ms == null || !Number.isFinite(ms)) return '—'
  if (ms <= 0) return 'doldu'
  const h = Math.floor(ms / 3600000)
  const m = Math.floor((ms % 3600000) / 60000)
  return h >= 24 ? `${Math.floor(h / 24)}g ${h % 24}s` : `${h}s ${m}dk`
}

export function pnlClass(v) {
  const n = Number(v)
  if (v == null || !Number.isFinite(n) || n === 0) return 'text-muted'
  return n > 0 ? 'text-success font-weight-bolder' : 'text-danger font-weight-bolder'
}

export function cloneDraft(d) {
  return JSON.parse(JSON.stringify(d))
}

export function poolTypeOf(slotCount, engines) {
  const on = ENGINE_KEYS.filter(e => engines[e] && engines[e].enabled)
  if (!on.some(e => (engines[e].min || 0) > 0)) return 'FREE'
  const locked = on.every(e => engines[e].min != null && engines[e].min === engines[e].max)
    && on.reduce((s, e) => s + (engines[e].min || 0), 0) === slotCount
  return locked ? 'LOCKED' : 'MIXED'
}

/** Free pool: drop every reservation, keep the caps. */
export function makeFree(engines) {
  ENGINE_KEYS.forEach(e => { if (engines[e]) engines[e].min = undefined })
}

/** Locked pool: split the slots evenly over the enabled engines (remainder to the first ones), min = max. */
export function makeLocked(slotCount, engines) {
  const on = ENGINE_KEYS.filter(e => engines[e] && engines[e].enabled)
  if (!on.length) return
  const base = Math.floor(slotCount / on.length)
  let rest = slotCount - base * on.length
  on.forEach(e => {
    const n = base + (rest > 0 ? 1 : 0)
    if (rest > 0) rest -= 1
    engines[e].min = n
    engines[e].max = n
  })
}
